import { render, staticRenderFns } from "./ASpost.vue?vue&type=template&id=744a8a01"
import script from "./ASpost.vue?vue&type=script&lang=js"
export * from "./ASpost.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports